export const {
  REACT_APP_ASSETS_URL: baseAssetsUrl,
  REACT_APP_API_MICROSERVICE_URL: baseUrl,
  REACT_APP_CHECKOUT_URL: checkoutUrl,
  REACT_APP_NODE_ENV_SHORT_NAME: envShortName,
  REACT_APP_VERSION: appVersion,
  REACT_APP_GOOGLE_ANALYTICS_ID: googleAnalyticsID,
  REACT_APP_BASE_URL_ENDPOINTS: endpointsUrl,
  REACT_APP_BASE_URL_INSIDE_LINKS: endpointsInsideSales,
  REACT_APP_BASE_URL_USERS: endpointsUsers,
  REACT_APP_BASE_URL_LIVE: endpointsLive,
  REACT_APP_BASE_URL_PUSH: endpointsPush,
  REACT_APP_BASE_URL_BUCKET: baseBucketUrl,
  REACT_APP_BASE_URL_PREVIEW_PROGRAM: baseUrlPreviewProgram,
} = process.env;

function isProductionEnv() {
  // create-react-app will always resolve build to production env
  // so to create a controlled "prod" environment even if production
  // build always resolve NODE_ENV to "prod" envShortName variable was created.
  return envShortName === 'prod';
}

function isDevelopmentEnv() {
  /// create-react-app will always resolve build to production env
  // so to create a controlled "dev" environment even if production
  // build always resolve NODE_ENV to "prod" envShortName variable was created.
  return envShortName === 'dev';
}

function isTestEnv() {
  return process.env.NODE_ENV === 'test';
}

export { isProductionEnv, isDevelopmentEnv, isTestEnv };
